<template>
  <section class="auth-form-container">
    <div class="auth-form-name">Sign in</div>
    <LoginForm :isAdmin="true" :onSubmit="login" />
  </section>
</template>

<script>
import LoginForm from '@/components/shared/LoginForm';

export default {
  name: 'LoginAdmin',
  components: { LoginForm },
  methods: {
    async login(data) {
      const res = await this.$http.post('admin/login', data);
      this.$store.commit('auth/login', res.data.access_token);
      this.$router.push('/admin');
    },
  },
};
</script>
